<template>
  <a-row>
    <a-row class="search-body">
      <a-col :span="24">
        <ent-search 
            :keywords="keywords" 
            :postdata="postdata" 
            @inputchange="inputChange" 
            @search="search" 
            @stats="showStatsPanel" 
            @tagging="showTagging" 
            @selectall="selectAll"/>
      </a-col>
    </a-row>
    <a-row class="content-list" v-if="tp_result.length > 0">
      <ent-list :list="tp_result" @checked="checkedItems" :key="refresh"/>
    </a-row>
    <a-modal v-model="statsPanel" title="" :footer="null" width="800px" height="1200px" @cancel="">
      <ent-stats :statistic="statistic"/>
    </a-modal>
    <a-modal v-model="tagPanel" title="" :footer="null" width="800px" @cancel="">
      <a-tree-select
        style="width: 225px"
        :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
        :treeData="tags"
        placeholder=''
        allowClear
        multiple
        treeDefaultExpandAll
        @change="changeTags"
        >
        <span style="color: #08c" slot="title" slot-scope="{key, value}">
          {{value}}
        </span>
      </a-tree-select>
      <a-button style="height: 32px;" @click="addProfileTags($event)">
        <a-icon type="plus"/>
      </a-button>
    </a-modal>
  </a-row>
</template>

<script>

import { EntSearch, EntList, EntStats} from '@/com/Ent'

export default {
  name: 'Ent',
  props: {
    postdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    result: {
      type: Array,
      default: function() {
        return []
      }
    },
    relationitem: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      tab: 'ent',
      keywords: "",
      tp_postdata: this.postdata,
      tp_result: this.result,
      tp_relationitem: this.relationitem,
      statistic: {},
      statsPanel: false,
      tagPanel: false,
      tags: [],
      selectNames: "",
      selectTags: "",
      refresh: 0
    }
  },
  components: {
    EntSearch,
    EntList,
    EntStats
  },
  watch: {
    tp_postdata(newvalue, oldvalue) {
      this.tp_postdata = newvalue
    },
    postdata(newvalue, oldvalue) {
      this.tp_postdata = newvalue
    },
    tp_result(newvalue, oldvalue) {
      this.tp_result = newvalue
    },
    result(newvalue, oldvalue) {
      this.tp_result = newvalue
    },
    tp_relationitem(newvalue, oldvalue) {
      this.tp_relationitem = newvalue
    },
    relationitem(newvalue, oldvalue) {
      this.tp_relationitem = newvalue
    }
  },
  methods: {
    showTagging: function(names, tags) {
      this.tagPanel = true
      this.tags = tags
      this.selectNames = names
    },
    changeTags: function(value, label, extra){
      this.selectTags = value
    },
    selectAll: function() {
      let result = this.$store.getters.getResult()
      for (let i = 0; i < result.length; i++) {
        result[i]["checked"] = true;
        this.$store.commit('updateresultitem', {result: result[i], index: i});
        this.tp_relationitem[result[i].entname] = result[i].entname;
      }
      this.$store.commit('updaterelationitem', this.tp_relationitem)
      this.$emit('checked', this.tp_relationitem)
      this.refresh += 1;
    },
    addProfileTags: function(e) {
      let postdata = {
        task: "ADD_PROFILE_TAGS",
        type: "ent",
        source: this.selectNames,
        tags: this.selectTags
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success("添加成功");
            that.tagPanel = false
          } else {
            that.$message.error("添加失败");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    showStatsPanel: function(stats) {
      this.statsPanel = true
      this.statistic = stats
    },
    inputChange: function(content) {
      this.keywords = content
    },
    checkedItems: function(item) {
      for(let key in item) {
        this.tp_relationitem[key] = key
      }
      let tag = false

      this.$store.commit('updaterelationitem', this.tp_relationitem)
      this.$emit('checked', this.tp_relationitem)

    },
    search: function(post, result, list) {
      this.tp_postdata = post;
      this.tp_result = result;
      this.$emit('search', this.tp_postdata, this.tp_result)
    }
  },
  created() {
    let relationitem = this.$store.getters.getRelationItem(1)
    let entnames = ""
    for (let key in relationitem) {
      entnames = entnames + relationitem[key] + "\n"
    }
    let content = ""
    if (this.postdata.content) {
      content = this.postdata.content
    }
    if (this.postdata.entname) {
      let ents = this.postdata.entname.split(" ")
      let names = ""
      for (let i = 0; i < ents.length; i++) {
        if (ents[i] != "") {
          names = names + ents[i] + "\n"
        }
      }
      content = names + content
    }

    if (entnames.split("\n").length > 1 && content == "") {
      this.keywords = entnames + content
    } else {
      this.keywords = content
    }
  }
}
</script>

<style scoped>
  .search-body {
    border-right: 0px solid #d1d5da;
    border-left: 0px solid #d1d5da;
    border-bottom: 0px solid #d1d5da;
    border-radius: 0px 0px 3px 3px;
  }
  .content-list {
    margin-top: 4px; 
    height: 100%;
    border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
    border-radius: 3px;
  }
  .pb8 {
    padding-bottom: 8px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
